import styled from 'styled-components';

export default styled.div`
  transform: translateX(50%) translateY(-100%) translateY(-0.6rem);
  position: absolute;
  padding: 0.3rem 0.6rem;
  height: 3rem;
  top: 1.5rem;
  right: 0;
  border-radius: 0.6rem;
  font-size: 1rem;
  background: rgba(39, 39, 39, 1)E6;
  color: #fff;
  user-select: none;
`;
